import { IItem } from '@checkout/items';
import { ICheckoutState } from '@checkout/state';
import { isOnlyOneCountry } from './address';
import breakpoints from './breakpoints';

export const xs = (): boolean => {
  return window.matchMedia(`(max-width: ${breakpoints.xs})`).matches;
};

export const sm = (): boolean => {
  return window.matchMedia(`(max-width: ${breakpoints.sm})`).matches;
};

export const lsm = (): boolean => {
  return window.matchMedia(`(max-width: ${breakpoints.lsm})`).matches;
};

export const md = (): boolean => {
  return window.matchMedia(`(max-width: ${breakpoints.md})`).matches;
};

export const lg = (): boolean => {
  return window.matchMedia(`(max-width: ${breakpoints.lg})`).matches;
};

export const evaluate = (subtree: any, context: {} = window) => {
  function getRawSnippet(script: any) {
    return (script.text || script.textContent || script.innerHTML || '');
  }

  function getSnippetType(script: any) {
    return (script.type || '');
  }

  if (subtree) {
    try {
      const scripts = subtree.getElementsByTagName('script');
      const scriptsAsArray = Array.from(scripts).filter(script => getSnippetType(script) !== 'application/json');

      scriptsAsArray.forEach((script) => {
        const unescaped = getRawSnippet(script).replace(/\\/gi, '');
        eval.call(context, unescaped);
      });
    } catch (error) {
      // tslint:disable-next-line:no-console
      console.error('Catched error in evaluate function:', error);
    }
  }
};

export const matches = (property: string, target: string) => {
  return function verify(object: {}) {
    return object[property] === target;
  };
};

export const preSelectCountry = (checkoutState: ICheckoutState) => {
  const { location, countries } = checkoutState;

  // Check if on countries list is only one country
  if (isOnlyOneCountry(countries)) {
    return countries[0].country;
  }

  // Check if location from GeoIp exist in countries list
  if (location && location.country && countries.find((item) => item.country === location.country) && location.shipTo) {
    return location.country;
  }

  // In other cases just let the client set country manually
  return null;
};

export function getDataAttributeValue(element: HTMLElement, data: string): string | undefined {
  // @ts-ignore
  return element.getAttribute(`data-${data}`);
}

export function getConfig<T>(element: HTMLElement): T {
  return (getDataAttributeValue(element, 'config') && JSON.parse(element.dataset.config as string));
}

const isObject = (item: Object): boolean => {
  return (item && typeof item === 'object' && !Array.isArray(item) && item !== null);
};

// this function merges properties of two objects (will merge and override source properties into target)
export const mergeDeep = <T>(target: T, source: Partial<T>): T => {
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        // tslint:disable-next-line:curly
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    });
  }
  return target;
};

export const getConfigContextValue = <T>(defaultConfig: T, externalConfig: Partial<T> | undefined): T => {
  if (externalConfig) {
    return mergeDeep<T>(defaultConfig, externalConfig);
  }
  return defaultConfig;
};

export const checkIfArrayOfStringsContainsElement = (source: string[], target: string): boolean => source.some((el) => target.includes(el));

export const createExpireDate = (expireDate: number) => new Date((new Date()).getTime() + expireDate);

export const deleteObjectByKey = (object: any, keyProp: string) => {
  const object2 = Object.keys(object).reduce((node, key) => {
    if (key !== keyProp) {
      node[key] = object[key];
    }
    return node;
  }, {});

  return object2;
};

export const selectItemById = (items: IItem[], productId: string): IItem | undefined => {
  return items.find((item) => item.item === productId);
};

export const isJsonString = (str: string) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const slugify = (str: string) =>
  str.toString().toLowerCase().trim()
    .replace(/\s+/g, '-')
    .replace(/&/g, '-and-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-');
